import * as React from 'react';
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/it"
import TestDataActions from "./testDataActions";

moment.locale("it")

function getDaysArrayByMonth(x) {
    let daysInMonth = moment(x, "MM").daysInMonth();
    let arrDays = [];
    let counter = 1;

    while (counter <= daysInMonth) {
      let current = moment(x, "MM").date(counter);
      arrDays.push(current);
      counter ++;
    }
  
    return arrDays;
  }

class TestData extends React.Component {
    constructor(props){
        super(props);
        this.state = {};

        this.componentName = "[ testData.jsx ]";
        this.selectChange = this.selectChange.bind(this);
    }

    selectChange(event) {
        console.log(this.componentName + " selectChange");
        this.props.selectChange(event.target.value);
    }

    render(){
        console.log(this.componentName + " Render ")
        return (
            <div> Giorni Mese Attuale
            <br />
            <select value={this.props.selected} onChange={this.selectChange} >
                <option key="01" value="01"> Gennaio </option>
                <option key="02" value="02"> Febbraio </option>
                <option key="03" value="03"> Marzo </option>
                <option key="04" value="04"> Aprile </option>
                <option key="05" value="05"> Maggio </option>
                <option key="06" value="06"> Giugno </option>
                <option key="07" value="07"> Luglio </option>
                <option key="08" value="08"> Agosto </option>
                <option key="09" value="09"> Settembre </option>
                <option key="10" value="10"> Ottobre </option>
                <option key="11" value="11"> Novembre </option> 
                <option key="12" value="12"> Dicembre </option>
            </select>
            
            <br />
            {console.log(this.props.selected)}
            {getDaysArrayByMonth(this.props.selected).map(x =>{return <div> {x.format("dddd DD")} </div>})}

            </div>
        );
    }
    
}

const mapStateToProps = state => {
    console.log(state.testDataReducer)
    return {
        selected: state.testDataReducer.selected,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        selectChange(newSelect) {
            dispatch(TestDataActions.changeSelect(newSelect));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TestData)